import { create } from 'zustand'

/** A toast's one button (WI-30: "Undo" after a control change). */
export interface ToastAction {
  label: string
  run(): void
}

interface ToastState {
  text: string | null
  action: ToastAction | null
  show(text: string, ms?: number, action?: ToastAction): void
  hide(): void
}

let timer: ReturnType<typeof setTimeout> | undefined

export const useToast = create<ToastState>((set) => ({
  text: null,
  action: null,
  show(text, ms = 2000, action) {
    clearTimeout(timer)
    set({ text, action: action ?? null })
    // A toast with a button stays long enough to reach it.
    timer = setTimeout(() => set({ text: null, action: null }), action ? Math.max(ms, 5000) : ms)
  },
  hide() {
    clearTimeout(timer)
    set({ text: null, action: null })
  },
}))
